<template>
  <div class="hotCourse" v-show="courseInfoData.length">
    <div class="hotClass">
      <p>精选课程</p>
    </div>
    <div class="tabClassify">
      <ul>
        <li
          v-for="(item, index) in classifyList"
          :key="index"
          @click="changeTab(index, item.recommendId)"
          :class="{ active: selectedIndex === index }"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>

    <ul class="courseList">
      <li v-for="(item, keys) in courseInfoData" :key="keys">
        <CombinationCard
          v-if="item.setType === 1"
          :item="item"
          :key="keys"
          @click.native="gioEvent(item)"
        />
        <HotCourseCard v-else :item="item" :key="keys" @click.native="gioEvent(item)" />
      </li>
    </ul>
    <van-skeleton v-if="showLoad" title row="10" />
    <EmptyData v-if="isEmpty" :emptyName="'noProductList'" />
  </div>
</template>
<script>
import { reqProducts, reqTypeList, reqMajorAd } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import {deepCopy, gioPlatform} from '@/utils/tools';
import EmptyData from '@/components/emptyData/emptyData.vue';

export default {
  components: {
    HotCourseCard,
    CombinationCard,
    EmptyData,
  },
  data() {
    return {
      classifyList: [], // 分类
      selectedIndex: 0,
      courseInfoData: [],
      showLoad: false,
      isEmpty: false,
    };
  },
  props: {
    examYear: {
      type: [String, Number],
      default: 0,
    },
  },
  watch: {
    examYear() {
      this.getTypeList();
    },
  },
  created() {},
  methods: {
    changeTab(index, recommendId) {
      if (this.selectedIndex === index) return;
      this.selectedIndex = index;
      this.getCourseAd(recommendId);
    },
    // 获取分类列表
    async getTypeList() {
      const res = await reqTypeList('HOME_SELECT_CLASS');
      if (res.code === 0) {
        let list = res?.data.find((item) => item.code === `select_class_${this.examYear}`);
        this.classifyList = JSON.parse(list.remark);
        const { recommendId } = this.classifyList[0];
        this.getCourseAd(recommendId);
      }
    },
    // 查询广告位
    async getCourseAd(recommendId) {
      this.showLoad = true;
      this.isEmpty = false;
      const { code, data } = await reqMajorAd(recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.showLoad = false;
        this.isEmpty = true;
      }
      this.resetProductData([]);
      this.courseInfoData = [];
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = allProductIds.length ? await reqProducts(allProductIds, endPoint) : {};
      const res1 = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      const resCourse = this.resetProductData(res.data || [], 2);
      const resPackage = this.resetCoursePackage(res1.data || []);
      const allCourse = [];
      recommendContentVOList.forEach((child) => {
        const findRes = [...resCourse, ...resPackage].find((course) => {
          const id = child.recommendType === 0 ? course.productId : course.packageId;
          return id === child.productId;
        });
        // eslint-disable-next-line no-unused-expressions
        findRes && allCourse.push(findRes);
      });
      this.courseInfoData = allCourse;
      this.showLoad = false;
      this.isEmpty = !allCourse?.length;
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    gioEvent(courseInfoData) {
      const { name } = courseInfoData;
      // 点击广告
            sessionStorage.setItem("back", "true"); //此处是为了返回到上一页  不加会直接返回到官网首页了

      // eslint-disable-next-line
      gio('evar.set', 'selectedCourse_evar', name);
      // eslint-disable-next-line
      gio('track', 'adClick_event', {
        adPosition_var: '精选课程', // 广告位置
        pageName_var: '首页', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: null, // 广告ID
        adName_var: name, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: courseInfoData?.setType === 1 ? '套餐' : '产品', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hotCourse {
  box-sizing: border-box;
  min-height: 100vh;
  padding: 0 36px;
  background: #f8f8f8;
}

.hotClass {
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  margin: 0 0 32px 0;
  overflow: hidden;
  line-height: 50px;
  // background: $bgWhite;
}

.hotClass > p {
  /* width: 4.85px; */
  float: left;
  margin-top: 32px;
  color: $fontColorBlack;
  font-weight: bold;
  font-size: 32px;
}

.courseList::-webkit-scrollbar {
  display: none;
}
.courseList {
  box-sizing: border-box;
  width: 100%;
  // height: auto;
  // min-height: 198px;
  padding: 20px 0;
  // background: #fff;
}
.courseList > li {
  position: relative;
  width: 679px;
  margin: 0 auto;
  margin-bottom: 18px;
  // padding: 20px 29px 25px 25px;
  background: $bgWhite;
  border-radius: 32px;
  // box-shadow: 10px 10px 14px 0 $borderColorGray;
  // margin-bottom: 25px;
  // padding: 0.32px;
  // background: rgba(255, 255, 255, 1);
  // border-radius: 16px;
  // box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
  // opacity: 1;
  .liveImg {
    position: absolute;
    top: 0;
    right: 0;
    width: 140px;
    height: 50px;
    border-radius: 0 16px 0 32px;
  }
}
::v-deep .van-skeleton {
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 6px;
}
.tabClassify {
  > ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 152px;
      height: 60px;
      margin-right: 20px;
      margin-bottom: 20px;
      color: #666;
      font-weight: 400;
      font-size: 28px;
      line-height: 60px;
      text-align: center;
      background: #f0f2f2;
      border-radius: 8px;
      &.active {
        color: #fff;
        background: #ff7f41;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>
